import React from 'react'
import { Typography, Tooltip, Skeleton } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useStyles } from './style'

const ScoreBadge = ({ title, description, vertical, ...props }) => {
  const classes = useStyles({ vertical })

  return (
    <div className={classes.root}>
      <Typography className={classes.title}> {title || <Skeleton />} </Typography>
      <Typography className={classes.score}>
        {props.children || <Skeleton />}
      </Typography>
      {description && (
        <Tooltip title={description}>
          <InfoOutlinedIcon className={classes.informationIcon} />
        </Tooltip>
      )}
    </div>

  )
}

export default ScoreBadge
